<template>
  <button
    type="button"
    class="tema-toggle"
    :aria-label="escuro ? tx.paraClaro : tx.paraEscuro"
    :title="escuro ? tx.claro : tx.escuro"
    @click="alternar"
  >
    <Sun v-if="escuro" class="h-5 w-5" />
    <Moon v-else class="h-5 w-5" />
  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Sun, Moon } from 'lucide-vue-next'
import { useTextos } from '../../i18n/idioma'

const tx = useTextos({
  pt: { paraClaro: 'Mudar para o tema claro', paraEscuro: 'Mudar para o tema escuro', claro: 'Tema claro', escuro: 'Tema escuro' },
  en: { paraClaro: 'Switch to light theme', paraEscuro: 'Switch to dark theme', claro: 'Light theme', escuro: 'Dark theme' },
  es: { paraClaro: 'Cambiar al tema claro', paraEscuro: 'Cambiar al tema oscuro', claro: 'Tema claro', escuro: 'Tema oscuro' },
})

// O tema inicial é aplicado no index.html antes da página desenhar (claro por padrão).
const CHAVE = 'tema-site'
const escuro = ref(document.documentElement.dataset.theme === 'dark')

const alternar = () => {
  escuro.value = !escuro.value
  const tema = escuro.value ? 'dark' : 'light'
  document.documentElement.dataset.theme = tema
  try {
    localStorage.setItem(CHAVE, tema)
  } catch {
    // Sem armazenamento (aba privada): vale só para esta visita
  }
}
</script>

<style scoped>
.tema-toggle {
  display: inline-grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid var(--a2-line-strong);
  color: var(--a2-ink);
  background: transparent;
  transition: background 0.2s ease, border-color 0.2s ease;
}

.tema-toggle:hover { background: var(--a2-card); border-color: var(--a2-primary-soft); }
.tema-toggle:focus-visible { outline: 2px solid var(--a2-primary-soft); outline-offset: 2px; }
</style>
